import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'manage-demand-component',
  templateUrl: './manage-demand.component.html',
  styleUrls: ['./manage-demand.component.scss']
})

export class ManageDemandComponent implements OnInit {

  public data: any;
  public columnsSettings: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public isDisplayCappingSettings: boolean;
  public emptyDataSettings: any;
  public activeEntities: boolean;
  public isInactiveLoaded: boolean;
  public gridFilters: any;
  public subscriptions: Array<any>;
  public gridName: string;
  public withAmount: boolean;

  constructor(public router: Router, public httpService: HttpService, public gridService: GridService, public sharedService: SharedService, public dictionaryService: DictionaryService, public modalsService: ModalsService, public userService: UserService, public ga: GoogleAnalyticsService) {
    this.data = [];
    this.columnsSettings = [];
    this.isLoading = false;
    this.isError = false;
    this.isDisplayCappingSettings = false;
    this.withAmount = false;
    this.emptyDataSettings = {
      title: 'WELCOME_TO_CEDATO',
      info: 'MANAGE_DEMAND_NO_DATA',
      buttonText: 'CREATE_NEW',
      buttonLink: '/demand/new'
    };
    this.activeEntities = true;
    this.isInactiveLoaded = false;
    this.gridName = 'MANAGE_DEMAND';
    this.gridFilters = {
      $$active: [this.activeEntities]
    };
    this.subscriptions = [];

  }

  ngOnDestroy() { }

  ngOnInit() {
    this.initialize();
    this.subscriptions.push(this.sharedService.getMessagesBus().subscribe((response: any) => {
      if (response.type === 'NETWORK_CHANGE') {
        this.activeEntities = true;
        this.isInactiveLoaded = false;
        this.gridFilters = {
          $$active: [this.activeEntities]
        };

        this.initialize();
      } else if (response.type === 'GRID_VALUE_CHANGE') {
        this.onActiveClick(response.data);
      }
    }));
    this.sharedService.setPageTitle('MANAGE_DEMAND');
  }

  initialize() {
    this.buildColumns();
    this.getDemands();
  }

  buildColumns() {
    this.columnsSettings = [
      { key: '$$active', label: 'ACTIVE', parseTooltipFunction: this.gridService.parseActiveDemandTooltip, isActiveButton: true },
      { key: 'vi', label: 'DEMAND_ID', filterType: 'INPUT', width: 130, primaryKey: true },
      { key: 'vn', label: 'DEMAND_NAME', filterType: 'INPUT', width: 350 },
      { key: 'cp', label: 'REACHED_CAPPING_SETTINGS', filterType: 'SELECT', width: 100, parseFunction: this.gridService.parseBoolean, parseTooltipFunction: this.gridService.parseBooleanTooltip },
      { key: 'pa', label: 'PARTNER_NAME', filterType: 'SELECT' },
      { key: 'vt', label: 'TYPE', filterType: 'SELECT', parseFunction: this.gridService.parseDemandType, parseTooltipFunction: this.gridService.parseDemandType },
      { key: 'dc', label: 'CAMPAIGN', tooltipKey: 'CAMPAIGN_TOOLTIP', filterType: 'SELECT', width: 84, parseFunction: this.gridService.parseBoolean, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'manage_campaigns' },
      { key: 'cr', label: 'RUNNING_CAMPAIGN', tooltipKey: 'RUNNING_CAMPAIGN_TOOLTIP', filterType: 'SELECT', width: 84, parseFunction: this.gridService.parseBoolean, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'manage_campaigns' },
      { key: 'ur', label: 'URL', filterType: 'INPUT' },
      { key: 'ev', label: 'ENVIRONMENT_SHORT', filterType: 'SELECT', parseFunction: this.gridService.parseMultipleEnvironments, parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip },
      { key: 'fi', label: 'FILTER_IVT', filterType: 'SELECT', width: 84, parseFunction: this.gridService.parseBoolean, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'pre_bid_pixalate' },
      { key: 'dl', label: 'DOMAIN_LIST', width: 84 },
      { key: 'il', label: 'IP_LIST', width: 84 },
      { key: 'um', label: 'REQUEST_LIMIT', width: 84, parseFunction: this.gridService.parseBoolean, parseTooltipFunction: this.gridService.parseBooleanTooltip },
      { key: 'pr', label: 'PREMIUM', featureFlag: 'vast_premium' },
      { key: 'cm', label: 'CPM', filterType: 'RANGE', char: '$', align: 'left', parseFunction: null, parseTooltipFunction: null },
      // { key: 'gd', label: 'GOOGLE_DEMAND', filterType: 'SELECT', parseFunction: this.gridService.parseBooleanTooltip, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'demand_segmentation' },
      // { key: 'id', label: 'INTENT_DEMAND', filterType: 'SELECT', parseFunction: this.gridService.parseBooleanTooltip, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'demand_segmentation' },
      { key: 'la', label: 'LIMITED_ASSIGNMENT', filterType: 'SELECT', parseFunction: this.gridService.parseBooleanTooltip, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'limit_assign' },
      { key: 'pr', label: 'FF_PREMIUM_VAST', filterType: 'SELECT', parseFunction: this.gridService.parseBooleanTooltip, parseTooltipFunction: this.gridService.parseBooleanTooltip, featureFlag: 'premium_vast' },
      { key: 'ss', label: 'ASSIGNED_SUPPLY', width: 200, parseFunction: this.gridService.parseNumeric, parseTooltipFunction: this.gridService.parseNumeric, defaultVisibility: false },
    ];

    if (this.userService.isAdmin()) {
      this.columnsSettings.push(
        { key: 'ep', label: 'EXTRA_PARAMS', filterType: 'SELECT', parseFunction: this.gridService.parseBoolean, parseTooltipFunction: this.gridService.parseBooleanTooltip }
      );
    }
  }

  getDemands() {
    const params: any = {};
    params.manage = 1;

    if (this.gridFilters.$$active && this.gridFilters.$$active.length === 1) {
      params.activeDemands = this.gridFilters.$$active[0] ? 1 : 0;
    }

    if (this.userService.getFeatureState('pre_bid_pixalate')) {
      params.pre_bid_pixalate = 1;
    }

    if (this.userService.getFeatureState('demand_segmentation')) {
      params.demand_segmentation = 1;
    }

    if (this.userService.getFeatureState('limit_assign')) {
      params.limit_assign = 1;
    }

    if (this.userService.getFeatureState('premium_vast')) {
      params.vast_premium = 1;
    }

    if (this.userService.getFeatureState('manage_campaigns')) {
      params.manage_campaigns = 1;
    }

    const customSettings: any = JSON.parse(localStorage.getItem('customGridSettings'));
    if (customSettings[this.gridName] !== undefined) {
      if (customSettings[this.gridName]['visibleColumns'].length) {
        this.withAmount = customSettings[this.gridName]['visibleColumns'].includes('ss');
      }
    }

    params.withAmount = this.withAmount ? 1 : 0;

    this.isLoading = true;
    this.subscriptions.push(this.httpService.post('vdsp_ws/getDemands', params).subscribe((response: any) => {
      let one: any;
      const data: Array<any> = [];
      let notDuplicated = false;

      for (let i = 0; i < response.length; i++) {
        one = {};
        one.vi = +response[i].vi;
        one.ep = +response[i].ep;
        one.vn = response[i].vn;
        one.pa = response[i].pa;
        one.ur = response[i].ur;
        if (!response[i].va && this.activeEntities) {
          this.activeEntities = false;
          this.gridFilters.$$active = [true, false];
        }
        one.ev = {
          is_desktop: this.sharedService.parseBoolean(response[i].ed),
          is_mobile_web: this.sharedService.parseBoolean(response[i].ew),
          is_mobile_app: this.sharedService.parseBoolean(response[i].ea),
          is_ctv: this.sharedService.parseBoolean(response[i].ec)
        };

        one.pn = (response[i].parentNetworkName) ? response[i].parentNetworkName : '';
        one.vt = +response[i].vt;

        if (this.userService.networkData && this.userService.networkData.mpnid) {
          if (this.userService.networkData.mpnid.includes(+response[i].pi)) {
            one.vt = this.dictionaryService.get('CEDATOX_MARKETPLACE');
          }
        }
        one.cp = (response[i].cp) ? parseInt(response[i].cp) : null;
        one.dl = (response[i].dl === '1') ? 'W' : ((response[i].dl === '2') ? 'B' : '');
        one.il = (response[i].il === '1') ? 'W' : ((response[i].il === '2') ? 'B' : '');
        one.um = response[i].um !== '0' && response[i].um !== 'SpotX Direct';
        one.cm = '';

        if (response[i].vt !== '1') {
          one.cm = '$' + this.gridService.parseNumericPadd({ value: response[i].cm });

          if (response[i].vt === '3' || response[i].vt === '4') {
            one.cm = '$' + this.gridService.parseNumericPadd({ value: response[i].fc });
          }
        }

        //FeatureFlagged Columns
        if (params.manage_campaigns === 1) {
          one.dc = this.sharedService.parseBoolean(response[i].dc);
          one.cr = this.sharedService.parseBoolean(response[i].cr);
        }

        if (params.demand_segmentation === 1) {
          one.gd = this.sharedService.parseBoolean(response[i].gd);
          one.id = this.sharedService.parseBoolean(response[i].id);
        }

        if (params.limit_assign === 1) {
          one.la = this.sharedService.parseBoolean(response[i].la);
        }

        if (params.vast_premium === 1) {
          one.pr = +response[i].pr;
        }

        if (params.pre_bid_pixalate === 1) {
          one.fi = this.sharedService.parseBoolean(response[i].fi);
        }

        if (this.withAmount) {
          one.ss = +response[i].ss;
        }

        //Special Columns
        one.$$active = this.sharedService.parseBoolean(response[i].va);
        one.$$actions = [
          { type: 'EDIT', link: true },
        ];

        notDuplicated = (one.vt === 1 && !this.userService.isCedatoXMarketplace());
        if (!notDuplicated) {
          one.$$actions.push({ type: 'COPY', link: false, linkOverride: '/demand/manage/' });
        }
        if (this.userService.networkData && this.userService.networkData.networkId) {
          one.networkId = +this.userService.networkData.networkId;
        }

        one.$$link = '/demand/manage/' + response[i].vi;
        data.push(one);
      }
      this.data = data;
      this.isLoading = false;

    }, (error: any) => {
      this.isLoading = false;
      this.isError = true;
    }));
  }

  onActiveClick(data: any) {
    const vastId: number = parseInt(data.dataItem.vi);
    const active: boolean = !(data.dataItem.$$active);
    const updatedData: Array<any> = _.cloneDeep(this.data);
    const itemIndex: number = _.findIndex(updatedData, { vi: vastId });
    const params = { vastId: vastId, is_active: active };
    this.gridFilters = data.filers;
    if (itemIndex > -1) {
      this.isLoading = true;
      this.subscriptions.push(this.httpService.post('vdsp_ws/updateVast', params).subscribe((response: any) => {
        this.isLoading = false;
        if (response.success) {
          if (response.vastId) {
            updatedData[itemIndex].$$active = active;
            this.data = updatedData;
            this.userService.networkData.active_demands_limit_reached = response.limit_reached;
            this.sharedService.showFlashMessage(this.dictionaryService.get('UPDATED_SUCCESSFULLY'), 'success');
          } else {
            this.sharedService.showErrorFlashMessage();
          }

        } else {
          if (response && response.errors && response.errors.active_demands_limit === 'NOT_VALID_BY_CLIENT') {
            this.sharedService.modalCedatoState = true;
            this.sharedService.modalCedatoHeader = 'WARNING';
            this.sharedService.modalCedatoBody = this.dictionaryService.get('LIMITS_NO_CREATE_MSG')('Demand');
            this.sharedService.modalCedatoButton = 'OK';
          } else if (response && response.errors) {
            this.sharedService.showErrorFlashMessage(response.errors);
          } else {
            this.sharedService.showErrorFlashMessage();
          }
        }

      }));
    } else {
      this.sharedService.showErrorFlashMessage();
    }
    this.isLoading = false;
  }

  onFilterChange($event: any) {
    if ($event.$$active) {
      this.gridFilters = $event;
      if (($event.$$active.length > 1 || !$event.$$active[0]) && !this.isInactiveLoaded) {
        this.activeEntities = false;
        this.isInactiveLoaded = true;
        this.getDemands();
      }
    }
  }

  createNewDemandBtnClick() {
    if (this.userService.networkData.active_demands_limit_reached) {
      this.sharedService.modalCedatoState = true;
      this.sharedService.modalCedatoHeader = 'WARNING';
      this.sharedService.modalCedatoBody = this.dictionaryService.get('LIMITS_NO_CREATE_MSG')('Demand');
      this.sharedService.modalCedatoButton = 'OK';
    } else {
      this.router.navigate(['/demand/new']);
    }
  }

  duplicateDemandBtnClick($event: any) {
    if (this.userService.networkData.active_demands_limit_reached) {
      this.sharedService.modalCedatoState = true;
      this.sharedService.modalCedatoHeader = 'WARNING';
      this.sharedService.modalCedatoBody = this.dictionaryService.get('LIMITS_NO_CREATE_MSG')('Demand');
      this.sharedService.modalCedatoButton = 'OK';
    } else {
      if ($event && $event.vi) {
        this.router.navigate(['/demand/duplicate/' + $event.vi]);
      } else {
        this.router.navigate(['/demand/new']);
      }
    }
  }

  onColumnsVisibilityChange($event: any) {
    const find = _.find($event, { key: 'ss' });
    this.columnsSettings = _.cloneDeep($event);

    if (find.visible && !this.withAmount) {
      this.withAmount = find.visible;
      this.getDemands();
    }
  }
}
